import { createSelector } from 'reselect'

const oeqSelector = state => state.oeq

const cancelSelector = createSelector(
	[oeqSelector],
	oeq => ({
		isModified: oeq.isModified,
	})
)

export default cancelSelector
